import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { PostmarkSuccess, Field } from "./FormBits";
import { VOLUNTEER_AREAS } from "../../lib/data";

const SIZES = ["XS", "S", "M", "L", "XL", "XXL"];
const SHIFTS = ["Setup", "Event", "Teardown", "Any"];

export const VolunteerForm = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", tshirt_size: "", shift: "" });
  const [interests, setInterests] = useState([]);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const toggle = (a) => setInterests((s) => (s.includes(a) ? s.filter((x) => x !== a) : [...s, a]));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.tshirt_size) return toast.error("Please select a t-shirt size");
    if (!form.shift) return toast.error("Please select a shift preference");
    setBusy(true);
    try {
      await api.post("/forms/volunteer", { ...form, interests });
      setDone(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  if (done)
    return (
      <PostmarkSuccess
        title="Welcome To The Crew!"
        message="Thank you for volunteering at Pak Fest 2026. Our team will reach out with shift details and next steps as the event gets closer."
        onReset={() => { setForm({ name: "", email: "", phone: "", tshirt_size: "", shift: "" }); setInterests([]); setDone(false); }}
      />
    );

  return (
    <form onSubmit={submit} className="max-w-2xl mx-auto space-y-6" data-testid="volunteer-form">
      <div className="grid md:grid-cols-2 gap-6">
        <Field label="Full Name" required>
          <input className="vintage-input" required value={form.name} onChange={set("name")} data-testid="vol-name" />
        </Field>
        <Field label="Email" required>
          <input type="email" className="vintage-input" required value={form.email} onChange={set("email")} data-testid="vol-email" />
        </Field>
        <Field label="Phone" required>
          <input className="vintage-input" required value={form.phone} onChange={set("phone")} data-testid="vol-phone" />
        </Field>
        <Field label="T-Shirt Size" required>
          <select className="vintage-input" required value={form.tshirt_size} onChange={set("tshirt_size")} data-testid="vol-tshirt">
            <option value="">Select…</option>
            {SIZES.map((s) => <option key={s}>{s}</option>)}
          </select>
        </Field>
      </div>

      <Field label="Areas Of Interest">
        <div className="grid sm:grid-cols-2 gap-3 mt-1">
          {VOLUNTEER_AREAS.map((a) => (
            <label key={a} className={`flex items-center gap-2 border-2 px-3 py-2 cursor-pointer font-mono text-xs transition-colors ${interests.includes(a) ? "border-rust bg-rust/10" : "border-forest/40"}`} data-testid={`vol-area-${a.replace(/[^a-z]/gi, "").toLowerCase()}`}>
              <input type="checkbox" className="accent-rust w-4 h-4" checked={interests.includes(a)} onChange={() => toggle(a)} />
              {a}
            </label>
          ))}
        </div>
      </Field>

      <Field label="Shift Preference" required>
        <div className="flex flex-wrap gap-3">
          {SHIFTS.map((s) => (
            <label key={s} className={`px-5 py-2 border-2 cursor-pointer font-mono text-xs uppercase tracking-wide transition-colors ${form.shift === s ? "border-rust bg-rust text-cream" : "border-forest/40 text-forest"}`} data-testid={`vol-shift-${s.toLowerCase()}`}>
              <input type="radio" name="shift" className="hidden" checked={form.shift === s} onChange={() => setForm({ ...form, shift: s })} />
              {s}
            </label>
          ))}
        </div>
      </Field>

      <button type="submit" disabled={busy} className="btn-rust w-full py-4 text-base disabled:opacity-60" data-testid="vol-submit">
        {busy ? "Submitting…" : "Sign Me Up"}
      </button>
    </form>
  );
};
